module.exports = __webpack_public_path__ + "static/media/dear-wanderer.b9f28c33.png";